import { LecturerRateDisplayType } from '../api/types/lecturers/price-rate/lecturer-rate-display-type';

export const calcLecturerHourUnits = (
  startAt: Date,
  endAt: Date,
  displayType: LecturerRateDisplayType,
): number => {
  const startMs = new Date(startAt).getTime();
  const endMs = new Date(endAt).getTime();
  const diffMinutes = Math.max(0, Math.floor((endMs - startMs) / 60000));
  const unitMinutes =
    displayType === LecturerRateDisplayType.AcademicHour ? 45 : 60;
  return diffMinutes / unitMinutes;
};

export const formatLecturerHourUnits = (
  startAt: Date,
  endAt: Date,
  displayType: LecturerRateDisplayType,
): string =>
  new Intl.NumberFormat('he-IL', { maximumFractionDigits: 2 }).format(
    calcLecturerHourUnits(startAt, endAt, displayType),
  );
